import CategoryTree from './component';
import enhance from './enhancers';

export default enhance(CategoryTree);
